module.exports = __webpack_public_path__ + "static/media/4.0498ef50.jpg";